// Styles for ModelDataSampleList component

import { useTheme } from '@mui/material';

// Consolidated styles object
export const useModelDataSampleListStyles = () => {
    const theme = useTheme();
    
    return {
        // Main layout
        pageContainer: { 
            padding: 3 
        },
        
        // Header section
        headerContainer: {
            display: 'flex',
            width: '100%',
            marginBottom: 4,
        },
        headerContent: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        backButton: { 
            height: 'fit-content',
            alignSelf: 'flex-start'
        },
        productLine: { 
            textAlign: 'center', 
            marginTop: 0.5, 
            marginBottom: 0.5 
        },
        
        // Filter section
        filtersContainer: {
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: 3,
            marginTop: 2,
        },
        filterContainer: { 
            marginBottom: 3,
            padding: 2,
            backgroundColor: '#f9f9f9',
            borderRadius: 1,
            border: '1px solid #e0e0e0',
        },
        filterForm: {
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            flexWrap: 'wrap',
        },
        filterLabel: {
            fontWeight: 500,
            marginBottom: 1,
        },
        filterControls: {
            display: 'flex',
            alignItems: 'center',
            gap: 2,
        },
        filterSelect: {
            padding: '8px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            minWidth: 180,
        },
        warningBadge: {
            marginLeft: 2,
            padding: '8px 12px',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            borderRadius: '4px',
        },
        
        // Table styling
        tableContainer: {
            width: '100%',
            overflowX: 'auto',
            '& .MuiTableCell-root': {
                boxSizing: 'border-box',
            }
        },
        stickyTable: {
            minWidth: 650,
            tableLayout: 'fixed',
            '& .MuiTableCell-root': {
                boxSizing: 'border-box',
            },
            '& .MuiTableHead-root': {
                position: 'sticky',
                top: 0,
                zIndex: 1,
                backgroundColor: '#fff'
            },
            '& .MuiTableCell-head': {
                height: 56,
                padding: '0 16px'
            },
            '& .MuiTableCell-body': {
                height: 52,
                padding: '0 16px'
            }
        },
        tableCell: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '&.MuiTableCell-sizeMedium': {
                padding: '6px 10px'
            }
        },
        tableCellHeader: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '&.MuiTableCell-head': {
                fontWeight: 'bold'
            },
            '&.MuiTableCell-sizeMedium': {
                padding: '8px 12px'
            }
        },
        columnHeaderContent: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%'
        },
        headerLabelContainer: {
            display: 'flex',
            alignItems: 'center',
            minWidth: 0,
            flexGrow: 1
        },
        columnMenuButton: {
            padding: 0,
            marginLeft: 1,
            color: 'rgba(0, 0, 0, 0.54)'
        },
        columnManagerDialog: {
            minWidth: 300
        },
        
        // Status badges
        statusDone: {
            backgroundColor: theme.palette.success.main,
            color: theme.palette.common.white,
            fontSize: '0.75rem',
            minWidth: '70px'
        },
        statusUpdate: {
            backgroundColor: theme.palette.warning.main,
            color: theme.palette.common.white,
            fontSize: '0.75rem',
            minWidth: '70px'
        },
        statusTodo: {
            backgroundColor: theme.palette.grey[300],
            color: theme.palette.primary.main,
            fontSize: '0.75rem',
            minWidth: '70px'
        },
        
        // Loading and empty states
        loadingContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '300px',
            gap: 2
        },
        
        noDataContainer: {
            textAlign: 'center', 
            mt: 4 
        },
    } as const;
}; 